import { Observable } from 'rxjs';
import { dcAttribute } from '../dcattribute.model';
import { dcAttributeValue } from '../dcattributevalue.model';

export class AttributeAndValues {
  constructor(
    public Attributes: Observable<dcAttribute[]>,
    public AttributeValues: Observable<dcAttributeValue[]>,
    public RequestID?: string
  ) {}
}
